import * as React from 'react';
import { connect } from 'react-redux';
import { CreateSurveyProps } from '../../common/CreateSurveyProps';
import { EditObject } from '../../common/constants';
import { ApplicationState } from '../../store';
import * as CreateSurveyStore from '../../store/CreateSurvey';

class Endnote extends React.Component<CreateSurveyProps> {

    handleTextAreaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        e.target.value = e.target.value;
            
        this.props.SetPropertyCreateSurvey(EditObject.Survey, e.target.name, e.target.value, false, 0, new Date());
    };
    
    render() {
        return(
            <React.Fragment>
                <div className="row g-3">
                    <div className='col-sm-12'>
                        <label className="form-label fw-bold">English Subheading <samp className="text-danger">&nbsp;*</samp></label>
                        <textarea className="form-control"
                            value={this.props.survey.endNotesEn}
                            onChange={this.handleTextAreaChange}
                            name='endNotesEn'
                            disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}
                            required
                            rows={5}></textarea>
                    </div>
                </div>
                <div className="row g-3">
                    <div className='col-sm-12'>
                        <label className="form-label fw-bold">French Subheading <samp className="text-danger">&nbsp;*</samp></label>
                        <textarea className="form-control"
                            value={this.props.survey.endNotesFr}
                            onChange={this.handleTextAreaChange}
                            name='endNotesFr'
                            disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}
                            required
                            rows={5}></textarea>
                    </div>
                </div>

                <div className="col-sm-12 mt-5">
                    <button className="btn btn-primary" onClick={() => this.props.MoveNextStep(this.props.step -1 )}>Previous</button>
                    <button className="btn btn-primary" onClick={() => this.props.MoveNextStep(undefined)}>Continue</button>
                </div>
            </React.Fragment>
        );
    }
};

export default connect(
    (state: ApplicationState) => state.createSurveyStore,
    CreateSurveyStore.actionCreators
)(Endnote as any);
